<section class="py-20 h-full">
  <div class="flex text-primary text-center items-center shadow-lg m-20 mt-0 p-10 justify-center">
    <div class="">
      <img src="assets/pago_confirmado.png" class="" alt="">
    </div>
    <div class="">
      <h1 class="text-3xl md:text-3xl font-bold pb-5">¡Gracias por sumarte a Argenfil!</h1>
      <p class="text-md font-light mb-10">Recibirás un mail con la confirmación de tu suscripción y,<br/> un <span class="font-bold">asesor comercial</span> estará en contacto para coordinar<br/> una <span class="font-bold">fecha de instalación.</span></p>
      <a href="#" class="bg-secondary text-sm font-medium px-4 py-1 rounded-full text-white items-center">Ir a mi perfil</a>
      <!--<button (click)="volver()" class="bg-secondary text-sm font-medium px-4 py-1 rounded-full text-white flex items-center mx-auto">Volver <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg></button>-->
    </div>    
  </div>
</section>
